import * as React from "react";
import styled, { css } from "../../../styled/index";
import {ButtonColors, ButtonSizes} from "../index";
import { Button } from "../index";

type OptionValue = string | number | null;

export interface ButtonGroupProps {
  size?: ButtonSizes;
  options: Array<{ name: string | React.ReactNode, value: OptionValue }>;
  onSelect: (o: { name: string | React.ReactNode, value: OptionValue }, e: React.MouseEvent<HTMLButtonElement>) => void | any;
  width: number | "auto";
  selected?: string | number | null;
  className?: string;
  buttonClassName?: string;
  round?: boolean;
  style?: React.CSSProperties;
  baseColor?: ButtonColors;
}

export interface ButtonGroupComponentProps {
  width: number | "auto";
  round?: boolean;
}

const getRoundButtonGroup = css`
  button {
    &:first-child {
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
    }
    &:last-child {
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
`;

const ButtonGroupComponent = styled("div")<ButtonGroupComponentProps>`
  display: inline-block;
  button {
    border-radius: 0;
    padding: 0;
    width: ${(props) => props.width === "auto" ? props.width : `${props.width}px`}; 
    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  };
  ${(props) => props.round ? getRoundButtonGroup : ""}
`;

export const ButtonGroup = (props: ButtonGroupProps) => (
  <ButtonGroupComponent width={props.width} round={props.round} className={props.className} style={props.style}>
    {props.options.map((o, i) =>
      <Button
        type="button"
        key={i}
        size={props.size}
        className={props.buttonClassName || ""}
        color={o.value === props.selected ? "primary" : props.baseColor}
        onClick={(e) => props.onSelect(o, e)}>
          {o.name}
      </Button>,
    )}
  </ButtonGroupComponent>
);
